import { AfterViewInit, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { AssessmentmanagerService } from 'src/app/services/assessments/assessmentmanager.service';
import { map } from 'rxjs/operators';
import { ComponentheaderService } from 'src/app/services/componentheader.service';
import { TableUtil } from 'src/app/models/tableutil';
import { FeatureGroups } from 'src/app/models/school/schooladminitem.model';
import { UtilService } from 'src/app/services/util.service';
@Component({
  selector: 'app-assessment-submissions',
  templateUrl: './assessment-submissions.component.html',
  styleUrls: ['./assessment-submissions.component.css']
})
export class AssessmentSubmissionsComponent implements OnInit {

  classID: number;
  assessmentID: number;
  moduleId:number;
  assessmentName: string;
  assessmentSubmissionList: any; //studentname, submit data, Scored, submissionID
  batchID: number;
    constructor(private assessmentService: AssessmentmanagerService, private router: Router, private header: ComponentheaderService, private activatedroute: ActivatedRoute, private util: UtilService) {
    this.assessmentID = this.activatedroute.snapshot.queryParams.aid;
    this.classID = this.activatedroute.snapshot.queryParams.classid;
    this.batchID = this.activatedroute.snapshot.queryParams.batchid;
  }


  async ngOnInit() {
    this.header.pageLoadingStarted(this);

    this.assessmentService.getAssessmentBreadCrumb(this.assessmentID).toPromise().then(
      (response: any) => {
        this.assessmentName = response.assessmentName;
        this.header.setHeaderDisplay(`Submissions : ${response.assessmentName}`,
          [
            {
              displaytext: 'School',
              route: `/user/schoolhome`,
              params: { schoolID: response.schoolID }
            },
            { 
              displaytext: 'Course',
              route: `/user/moduledetails`,
              params: { moduleID: response.moduleID }
            },
            { 
              displaytext: 'Lesson' ,
              route: `/user/lesson`,
              params: { classid: this.classID }
            },
            {
              displaytext: "Assessments",
              route: `/user/assessmentconsole`,
              params: { classid: this.classID,batchid:this.batchID }
            },
            {
              displaytext: response.assessmentName,
              route: `/user/assessmentdetails`,
              params: { classid: this.classID,batchid:this.batchID, aid: response.assessmentID },
            },
            {
              displaytext: 'Submissions',
              route: `/user/assessmentsubmissions`,
              params: { aid: this.assessmentID, classid: this.classID, batchid: this.batchID },
            },
          ],
          []);
          this.moduleId = response.moduleID;
      }
    );
    
    if(!await this.util.hasFeature(FeatureGroups.ASSESSMENTS)){
      this.util.notifyFeatureNotAvailable(FeatureGroups.ASSESSMENTS);
      this.header.pageLoadingDone(this);
      this.router.navigate(['/user/lesson'], { queryParams: { classid: this.classID }});
      return;
    }

      const data = await this.assessmentService.getAssessmentSubmissions(this.assessmentID, this.batchID);
      this.assessmentSubmissionList = data; 
      this.header.pageLoadingDone(this);
    
  }

  exportToExcel(){
    this.header.pageLoadingStarted(this);
    this.assessmentName = this.assessmentName.substring(0, 31);
    TableUtil.exportTableToExcel("submissionlist", this.assessmentName);
    this.header.pageLoadingDone(this);
  }

}
